<template>
  <div id="main-contract-points-box">
    <AppTitle expandTitle titulo="Contrato de Serviço" />

    <div class="is-flex is-justify-content-center main-contract-points-container">
      <div class="main-contract-points-box">
        <div class="content">
          <p class="initial-section-text">
            Fizemos o máximo para simplificar o nosso contrato. Abaixo um breve resumo de alguns
            pontos importantes do contrato de serviço:
          </p>

          <p>
            Caso queira, você pode acessar o
            <a download :href="fileServer('contrato.pdf', 'files')" target="_blank"
              >contrato de serviço</a
            >
            completo.
          </p>

          <ul>
            <li class="initial-section-text">
              O acesso à plataforma SELCORP está sujeito à contratação de um plano ou à compra de
              créditos, conforme a modalidade escolhida pelo licitante.
            </li>
            <li>
              O licitante é responsável por cumprir todas as regras dos editais e manter sua
              documentação fiscal em conformidade.
            </li>
            <li>
              O uso do sistema é feito por meio de senha e chave eletrônica de uso exclusivo, cuja
              segurança é de responsabilidade do licitante.
            </li>
            <li>
              A SELCORP poderá alterar as condições contratuais mediante aviso prévio, sendo
              garantido ao licitante o direito de rescindir o contrato caso não concorde.
            </li>
            <li>
              Os dados pessoais são tratados de acordo com a LGPD, com medidas de segurança
              adequadas.
            </li>
          </ul>
        </div>

        <h1 class="title" id="table-title">Formas de Cobranças</h1>

        <table id="custom-table">
          <tr class="table-row">
            <td class="table-text">Plano trimestral</td>
            <td class="table-text second-column-text">R$ 567,00</td>
          </tr>

          <tr class="table-row">
            <td class="table-text">Plano Semestral</td>
            <td class="table-text second-column-text">R$ 999,00</td>
          </tr>

          <tr class="table-row">
            <td class="table-text">Plano Anual</td>
            <td class="table-text second-column-text">R$ 1550,00</td>
          </tr>

          <tr class="table-row">
            <td class="table-text">Plano Avulso</td>
            <td class="table-text second-column-text">R$ 158,00/contratação</td>
          </tr>
        </table>

        <p class="last-updated">Atualizado em 15/07/2025</p>
      </div>
    </div>
  </div>
</template>

<script>
import AppTitle from '@/components/AppTitulo';

import { fileServer } from '@/utils/functions';

export default {
  name: 'MainContractPoints',
  components: {
    AppTitle,
  },
  data() {
    return {
      fileServer,
    };
  },
};
</script>

<style lang="scss" scoped>
#custom-table {
  width: 100%;
}

#table-title {
  margin-bottom: 0.5rem;
  margin-top: 2.5rem;
}

.initial-section-text {
  font-size: 16px;
}

.main-contract-points-box {
  margin: 3rem 0;
  max-width: 800px;
}

.second-column-text {
  max-width: 110px;
}

.last-updated {
  font-size: 0.875rem;
  color: #747373;
  margin-top: 8px;
  font-style: italic;
  text-align: right;
}

.table-row {
  border-bottom: 1px solid black;
  height: 70px;
}

.table-text {
  font-size: 15px;
}

table {
  td {
    vertical-align: inherit;
  }
}

ul li {
  margin: 15px 0;
}

@media (max-width: 1023px) {
  .main-contract-points-box {
    margin: 3rem;
  }
}

@media (max-width: 768px) {
  .table-row {
    height: 100px;
  }
}

@media (max-width: 577px) {
  .table-row {
    height: 120px;
  }
}

@media (max-width: 386px) {
  .table-row {
    height: 150px;
  }
}
</style>
